import api from "@/lib/api";

function urlBase64ToUint8Array(value) {
  const padding = "=".repeat((4 - (value.length % 4)) % 4);
  const base64 = (value + padding).replace(/-/g, "+").replace(/_/g, "/");
  return Uint8Array.from(atob(base64), (c) => c.charCodeAt(0));
}

export function pushSupported() {
  return "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
}

export function pushPermission() {
  return pushSupported() ? Notification.permission : "unsupported";
}

// Subscribe the current user to Web Push. `interactive` controls whether we may prompt.
export async function enablePush({ interactive = true } = {}) {
  if (!pushSupported()) throw new Error("Push notifications aren't supported in this browser.");
  if (Notification.permission === "denied") throw new Error("Notifications are blocked in your browser settings.");
  if (Notification.permission !== "granted") {
    if (!interactive) return null;
    const perm = await Notification.requestPermission();
    if (perm !== "granted") throw new Error("Notification permission was not granted.");
  }
  const { data } = await api.get("/push/public-key");
  if (!data.publicKey) throw new Error("Push is not configured on the server.");
  const reg = await navigator.serviceWorker.ready;
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(data.publicKey),
    });
  }
  await api.post("/push/subscribe", sub.toJSON());
  return sub;
}
